import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UsuarioLogado } from '../models/usuario-logado';
import { TipoSistema, PerfilDoUsuario } from 'src/app/models/enum';
import { AppConfigService } from './app-config.service';
import { AutenticacaoService } from './autenticacao.service';
import { NotificacaoService } from './notificacao.service';
import { CarregandoService } from './carregando.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  alterouConfiguracao: BehaviorSubject<any>;
  minimizarMenuBS: BehaviorSubject<boolean>;

  usuarioLogado: UsuarioLogado;

  constructor(private appConfigService: AppConfigService, private autenticacaoService: AutenticacaoService,
    private carregandoService: CarregandoService, private notificacaoService: NotificacaoService) {
    this.alterouConfiguracao = new BehaviorSubject(this.consultarConfiguracao());
    this.minimizarMenuBS = new BehaviorSubject(false);
  }

  consultarConfiguracao() {
    if (localStorage.getItem('configuracao') === null) {
      localStorage.setItem('configuracao', JSON.stringify(this.appConfigService.getTemplates()[0]));
      return this.appConfigService.getTemplates()[0];
    } else {
      return JSON.parse(localStorage.getItem('configuracao'));
    }
  }

  selecionaConfiguracao(configuracao) {
    localStorage.setItem('configuracao', JSON.stringify(configuracao));
    this.alterouConfiguracao.next(configuracao);
  }

  minimizarMenu() {
    this.minimizarMenuBS.next(true);
  }

  async consultaUsuario(semLoading: boolean = false): Promise<UsuarioLogado> {
    try {
      if (!semLoading) {
        this.carregandoService.mostra('consultaUsuario');
      }

      if(!this.usuarioLogado) {
        this.usuarioLogado = await this.autenticacaoService.buscarUsuarioLogado().toPromise();
      }

      return this.usuarioLogado;

    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {

      if (!semLoading) {
        this.carregandoService.esconde('consultaUsuario');
      }
    }
  }

  async administrador(semLoading: boolean = false): Promise<boolean> {
    const usuario = await this.consultaUsuario(semLoading);

    return usuario.roles.indexOf('Administrador') > -1 ||
      usuario.roles.indexOf('Suporte') > -1;
  }

  async suporte(): Promise<boolean> {
    const usuario = await this.consultaUsuario();

    return usuario.roles.indexOf('Suporte') > -1;
  }

  async integrador(): Promise<boolean> {
    const usuario = await this.consultaUsuario();

    return usuario.roles.indexOf('Integrador') > -1;
  }

  async perfil(): Promise<PerfilDoUsuario> {
    const role = (await this.consultaUsuario()).roles[0];

    switch (role) {
    case 'Integrador':
      return PerfilDoUsuario.Integrador;
    case 'Vendedor':
      return PerfilDoUsuario.Vendedor;
    case 'Administrador':
      return PerfilDoUsuario.Administrador;
    case 'Suporte':
      return PerfilDoUsuario.Suporte;
    }
  }

  limparUsuarioAtual() {
    this.usuarioLogado = null;
  }
}
